module.exports = __webpack_public_path__ + "img/prize5.6ac4fda8.png";